export enum ComposeEmailCategory {
  New,
  Reply,
  Forward,
  Resend
}
